/*
  «Изменить данные» в шапке карточки счёта (21.10.2026, замечание владельца): номер и адрес
  самого лицевого счёта. До этого дня после заведения они не менялись вовсе, и опечатка в
  номере означала удаление счёта.

  Окно говорит об ограничениях заранее, а не после отказа: правка закрыта, пока по счёту
  есть документы (в них прежние значения), а счёт, который 1С может принести под прежним
  номером, при смене номера получил бы двойника. Сведения о помещении - площадь, комнаты,
  этаж, вид собственности - правятся на вкладке «Должники», своим окном.
*/

import { useState } from 'react'

import { api } from '../../api/client.js'
import { Field } from '../Common.jsx'
import FormDialog from './FormDialog.jsx'

function Dialog({ card, onSaved, onClose }) {
  const [number, setNumber] = useState(card.number)
  const [address, setAddress] = useState(card.address)

  const body = () => {
    const result = {}
    if (number.trim() !== card.number) result.number = number.trim()
    if (address.trim() !== card.address) result.address = address.trim()
    return result
  }
  const changed = Object.keys(body()).length > 0

  return (
    <FormDialog
      title={`Данные счёта № ${card.number}`}
      submitLabel="Сохранить"
      canSubmit={changed && number.trim() !== '' && address.trim().length >= 5}
      wide
      onSubmit={() => api.editAccount(card.account_id, body())}
      onSaved={onSaved}
      onClose={onClose}
    >
      <div className="row">
        <Field label="Номер лицевого счёта" width="s">
          <input
            className="field__input"
            value={number}
            maxLength={64}
            onChange={(event) => setNumber(event.target.value)}
          />
        </Field>
        <Field label="Адрес помещения" width="l">
          <input
            className="field__input"
            value={address}
            maxLength={500}
            onChange={(event) => setAddress(event.target.value)}
          />
        </Field>
      </div>
      <div className="muted">
        Пока по счёту есть документы, данные не меняются: в документах прежние номер и адрес.
        Сначала удалите документы на вкладке «Суд». Номер должен быть свободен в вашем портфеле.
        Если счёт приходит из 1С без кода записи, поправьте номер и в 1С: иначе обмен принесёт его
        заново под прежним номером. Исправленный адрес обмен не перезапишет.
      </div>
    </FormDialog>
  )
}

export default function AccountEditButton({ card, onDone }) {
  const [open, setOpen] = useState(false)
  return (
    <>
      <button type="button" className="button button--quiet" onClick={() => setOpen(true)}>
        Изменить данные
      </button>
      {open ? (
        <Dialog
          card={card}
          onSaved={() => onDone('Данные счёта сохранены.')}
          onClose={() => setOpen(false)}
        />
      ) : null}
    </>
  )
}
